import { useQuery } from "react-query"
import { ENABLE_HARDCODED_PRODUCT } from "../lang/da"
import { useHttp } from '../providers/http'
import addToList from "../should-be-replaced"

const useProducts = () => {
    const http = useHttp()

    return useQuery("products", () => {
        return http.get("/bookings/products")
            .then(response => {
                const x = response.data.map(firstLevelCategory => {
                    return {
                        ...firstLevelCategory,
                        childs: firstLevelCategory.childs.map(secondLevelCategory => {
                            return {
                                ...secondLevelCategory,
                                categoryId: firstLevelCategory.id,
                                categoryUpsale: firstLevelCategory.upsales,
                                categoryUpsaleProducts: firstLevelCategory.upsale_products,
                                categoryMultipleSelect: firstLevelCategory.multiple_select,
                                categoryIcon: firstLevelCategory.icon,
                                products: secondLevelCategory.products.map(product => {
                                    return {
                                        ...product,
                                        categoryId: firstLevelCategory.id,
                                        secondLevelCategoryId: secondLevelCategory.id,
                                        icon: firstLevelCategory.icon,
                                        categoryUpsaleProducts: firstLevelCategory.upsale_products,
                                        categoryUpsale: firstLevelCategory.upsales,
                                        secondLevelCategoryUpsaleProducts: secondLevelCategory.upsale_products,
                                        secondLevelCategoryUpsale: secondLevelCategory.upsales,
                                        categoryMultipleSelect: firstLevelCategory.multiple_select,
                                        secondLevelCategoryMultipleSelect: secondLevelCategory.multiple_select,
                                    }
                                })
                            }
                        })
                    }
                })

                if (ENABLE_HARDCODED_PRODUCT) {
                    return addToList(x);
                }

                return x;
            })
            .catch(err => {
                throw err;
            })
    }, {
        staleTime: Infinity
    })
}

export default useProducts;